
import useAsValidateContainer from './useAsValidateContainer'

export default {
  name: 'MsForm',

  emits: ['submit'],

  provide: {

  },

  props: {
    autoFocus: {
      type: Boolean,
      default: true
    }
  },

  setup (props: any) {
    const { form, reset, isValid, focusFirstError } = useAsValidateContainer(props.autoFocus)

    return {
      form,
      isValid,
      reset,
      focusFirstError
    }
  }
}
